export const AZURE_OAUTH_ACCOUNT_ID_KEY = 'azure_oauth_account_id'

export const getAzureOauthCacheKey = (partnerId: string) =>
  `azureOauth:${partnerId}`

export const setAzureOauthAccountId = (accountId: string) => {
  sessionStorage.setItem(AZURE_OAUTH_ACCOUNT_ID_KEY, accountId)
}

export const getAzureOauthAccountId = (): string | null =>
  sessionStorage.getItem(AZURE_OAUTH_ACCOUNT_ID_KEY)

export const clearAzureOauthAccountId = () => {
  sessionStorage.removeItem(AZURE_OAUTH_ACCOUNT_ID_KEY)
}

export const clearAzureOauthCache = (partnerId: string) => {
  localStorage.removeItem(getAzureOauthCacheKey(partnerId))
}
